import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const DiamondShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 268.4 425.3",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M0 212.7l134.2 212.6 134.2-212.6L134.2 0z"
    })
  });
};

export { DiamondShape };
//# sourceMappingURL=DiamondShape.js.map
